import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidateJustAdd } from 'services/loans/manager'
import posthog from 'posthog-js'

export default function useSetJustAdd() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyAddJust) => {
            return ManagementAddNewLoanValidateJustAdd(payload)
        },
        onSuccess: (response, variables) => {
            posthog.capture('loan_granted', {
                // the wizard emits the same event; without this the two flows
                // are one undifferentiated number
                flow: 'legacy_form',
                record_only: true,
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.success('وام با موفقیت ثبت گردید')
            navigate(`/fund/${state?.payload?.moneyPool}`, {
                state: { poolShipId: state?.payload?.poolShip },
            })
        },
        onError: (error: any) => {
            posthog.capture('loan_grant_failed', {
                flow: 'legacy_form',
                step: 'final',
                record_only: true,
                status: error?.response?.status,
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.error('مشکلی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
